<script>
  export let text = "Button Text";
</script>

<button on:click>{text}</button>

<style>
  button {
    font-family: "Roboto", sans-serif;
    text-transform: uppercase;
    outline: 0;
    background: #4caf50;
    width: 100%;
    border: 0;
    padding: 15px;
    color: #ffffff;
    font-size: 14px;
    -webkit-transition: all 0.3 ease;
    transition: all 0.3 ease;
    cursor: pointer;
  }
  button:hover,
  button:active,
  button:focus {
    background: #43a047;
  }
</style>
